import { Button, Collection, Flex, Heading, Text } from "@aws-amplify/ui-react";
import React from "react";
import GameCard from "./GameCard";
import { useHistoryContext } from "../hooks/useHistoryContext";

import ArrowLeftIcon from "../../../components/icons/ArrowLeftIcon";

import { useNavigate } from "react-router-dom";
import GibblyLoader from "../../../components/GibblyLoader";
import { PageIndex, PageTitle } from "../../../util/SEO";

export default function HistoryPage() {
  PageTitle("Games History | Gibbly");
  PageIndex("noindex");
  const { lobbies } = useHistoryContext();
  const navigate = useNavigate();
  return (
    <Flex
      padding={"medium"}
      paddingTop={"large"}
      width={"100%"}
      direction={"column"}
      gap={{ base: "medium", medium: "xxxs" }}
    >
      <Button
        alignSelf={"start"}
        variation="link"
        size="large"
        onClick={() => navigate("/dashboard/library")}
      >
        <ArrowLeftIcon />
      </Button>

      <Heading id="pageTitle">Games History</Heading>
      <Text paddingBottom={"large"} fontFamily={"Poppins"}>
        Hosted Games
      </Text>
      {lobbies ? (
        <Collection
          items={lobbies}
          type="list"
          direction="row"
          wrap={"wrap"}
          alignItems={{ base: "center", medium: "left" }}
          searchNoResultsFound={
            <Flex justifyContent="left" paddingTop={"large"}>
              {/* <i>
                      <Text fontWeight={"semibold"} color={"purple.80"}>
                        No assignments yet. Add a game to get started!
                      </Text>
                    </i> */}
            </Flex>
          }
        >
          {(lobby) => <GameCard key={lobby.id} lobby={lobby}></GameCard>}
        </Collection>
      ) : (
        <Flex justifyContent={"center"}>
          <GibblyLoader />
        </Flex>
      )}
    </Flex>
  );
}
